
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useEmergencyOptimizedExerciseQuery = ({ 
  routineId, 
  enabled = true 
}: { 
  routineId: string; 
  enabled?: boolean; 
}) => {
  return useQuery({
    queryKey: ["emergency-exercises", routineId],
    queryFn: async () => {
      console.log(`🚨 EMERGENCY: Fetching exercises for routine ${routineId}`);
      
      // Ultra-simplified query - only essential fields
      const { data, error } = await supabase
        .from("exercises")
        .select(`
          id,
          name,
          sets,
          exercise_rest_time,
          set_rest_time,
          position
        `)
        .eq("routine_id", routineId)
        .order("position", { ascending: true })
        .limit(20); // Strict limit

      if (error) {
        console.error("❌ EMERGENCY: Exercise query failed:", error);
        throw error;
      }

      return data?.map(exercise => ({
        ...exercise,
        exercise_rest_time: exercise.exercise_rest_time !== null ? Number(exercise.exercise_rest_time) : null,
        set_rest_time: exercise.set_rest_time !== null ? Number(exercise.set_rest_time) : null,
        // Set safe defaults for missing fields
        reps: 0,
        weight: 0,
        set_data: [],
        video_url: null
      })) || [];
    },
    enabled: !!routineId && enabled,
    staleTime: 300000, // 5 minutes - very conservative
    gcTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1, // Only one retry
    retryDelay: 3000
  });
};
